module.exports = __webpack_public_path__ + "static/why-image-89c5de085400964f30abdb8bb6675793.png";